
import { trackEvent, EventType } from "@/helpers/AmplitudeHelper";
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";
import LoadingSpinnerSmall from "../LoadingSpinnerSmall.vue";
import { isProEnabled } from "@/helpers/FeatureFlagHelper";

enum SetupFlow {
  start = "start",
  unsubbed = "unsubbed",
}

export default defineComponent({
  name: 'SignUpReportSuccessModal',
  components: {
    LoadingSpinnerSmall,
  },
  data() {
    return {
      SetupFlow,
      setupStep: SetupFlow.start,
      isLoadingModal: false,
      proEnabled: isProEnabled,
    }
  },
  emits: ["close"],
  methods: {
    ...mapActions(['toggleSetupTariffsModal', 'cancelReportTariff', 'reactivateReportTariff']),
    closeModal() {
      document.body.classList.remove("is-popup-opened");
      document.body.classList.add("is-popup-closed");
      setTimeout(() => {
        this.toggleSetupTariffsModal();
        document.body.classList.remove("is-popup-closed");
        this.setupStep = SetupFlow.start
      }, 250);
    },
    goToTariff(btn: string) {
      this.closeModal()
      if (btn === 'more_info') {
        trackEvent(EventType.reports_profile_setup_details)
      }
      const url = this.$router.resolve({
        name: isProEnabled ? 'pro' : 'reports',
      }).href
      window.open(url, '_blank', 'noopener')
    },
    async unsubscribe() {
      this.isLoadingModal = true
      await this.cancelReportTariff()
      this.isLoadingModal = false
      trackEvent(EventType.reports_profile_setup_deactivate, undefined, { reports_status: 'cancelled_customer' })
      this.setupStep = SetupFlow.unsubbed
    },
    async reactivate() {
      this.isLoadingModal = true
      await this.reactivateReportTariff()
      this.isLoadingModal = false
      trackEvent(EventType.reports_profile_setup_restore, undefined, { reports_status: 'customer' })
      this.closeModal()
    },
  },
  computed: {
    ...mapGetters(['showSetupTariffsModal', 'getTariffExpiryDate', 'isLoading']),
    title(): string {
      if (this.setupStep === SetupFlow.start) {
        return this.$t(
          isProEnabled ? 'profile_page.pro_title' : 'profile_page.reports_title'
        )
      } else {
        return this.$t('reports.deactivated_title')
      }
    },
    tariffExpiryDate() {
      if (!this.getTariffExpiryDate) {
        return null
      }
      const expiryDate = this.getTariffExpiryDate
      const day = expiryDate.getDate().toString().padStart(2, "0");
      const month = (expiryDate.getMonth() + 1).toString().padStart(2, "0");
      const year = expiryDate.getFullYear().toString();
      return `${day}.${month}.${year}`;
    },
  },
});
